"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CxLink = void 0;
//#region Import
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
//import { useCxAppBasename } from '../CxAppProvider';
//#endregion
//#region React components
function CxLink(props) {
    //return <Link {...props} to={`${useCxAppBasename()}${props.to}`} />;
    return react_1.default.createElement(react_router_dom_1.Link, { ...props, to: `${props.to}` });
}
exports.CxLink = CxLink;
//#endregion
//# sourceMappingURL=CxLink.js.map